import React from "react";

interface CommentIconProps {
  size?: number;
}

export const CommentIcon = ({ size = 28 }: CommentIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="CBasicCheckbox__icon"
    >
      <path
        d="M23.2153 20.7812C23.1503 20.5417 23.2941 20.2087 23.4314 19.9686C23.4741 19.897 23.5205 19.8276 23.5703 19.7608C24.7475 17.9754 25.375 15.8838 25.3749 13.7452C25.3941 7.60648 20.3038 2.625 14.0092 2.625C8.51971 2.625 3.93745 6.42797 2.86667 11.4762C2.70623 12.2246 2.62521 12.9879 2.62495 13.7534C2.62495 19.9008 7.51893 24.9605 13.8135 24.9605C14.8142 24.9605 16.165 24.7089 16.9017 24.5027C17.6383 24.2966 18.3739 24.0231 18.5636 23.9498C18.7577 23.8752 18.9638 23.8369 19.1717 23.8366C19.3989 23.8358 19.6238 23.881 19.8329 23.9695L23.5424 25.3083C23.6236 25.3433 23.7097 25.3658 23.7978 25.375C23.8672 25.3748 23.9359 25.3608 23.9999 25.3338C24.064 25.3069 24.122 25.2675 24.1707 25.218C24.2193 25.1684 24.2577 25.1097 24.2835 25.0452C24.3094 24.9807 24.3221 24.9118 24.3211 24.8423C24.3166 24.7814 24.3056 24.7211 24.2883 24.6624L23.2153 20.7812Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      ></path>
    </svg>
  );
};
